import { render, staticRenderFns } from "./BlockType3List.vue?vue&type=template&id=05856aea&scoped=true"
import script from "./BlockType3List.vue?vue&type=script&lang=ts"
export * from "./BlockType3List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType3List.vue?vue&type=style&index=0&id=05856aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05856aea",
  null
  
)

export default component.exports